import { render, staticRenderFns } from "./wy-home-experience-automation-panel-bes-bas-summary.vue?vue&type=template&id=71c13e2e&"
import script from "./wy-home-experience-automation-panel-bes-bas-summary.vue?vue&type=script&lang=js&"
export * from "./wy-home-experience-automation-panel-bes-bas-summary.vue?vue&type=script&lang=js&"
import style0 from "./wy-home-experience-automation-panel-bes-bas-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports